import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageUploader from 'v4/components/image-uploader';
import { UpdateRoomName } from 'v4/store/actions/global.data.actions';

function GroupImgUploader({
  isGrpImgUploaderOpen,
  onClose,
  fetchRoomList,
  setSelectedChat,
  roomId,
  selectedChat,
  setRoomId,
}) {
  const [cropType, setCropType] = useState();
  const [profilePostData, setProfilePostData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const { t } = useTranslator();

  const handlePopups = (type) => {
    setCropType(type);
  };

  const uploadCropedImg = async (img) => {
    const formData = {};

    if (cropType === 'profilePhoto') {
      formData['profile_pic'] = img;
    } else {
      formData['profile_banner_pic'] = img;
    }

    formData['post_description'] = profilePostData?.post_description ?? '';
    formData['show_on_feed'] = profilePostData?.show_on_feed ?? false;

    setLoading(true);
    await dispatch(
      UpdateRoomName({
        room_name: selectedChat?.room_name,
        room_id: roomId,
        file: img,
      })
    );

    setSelectedChat((prev) => ({
      ...prev,
      avatar_url: URL.createObjectURL(img), // temporary preview
    }));

    // Refresh the room list and update selected chat
    await fetchRoomList('fromUpdateImage');

    setProfilePostData(null);
    onClose();
    setRoomId(roomId);
    setLoading(false);
  };

  return (
    <Modal isOpen={isGrpImgUploaderOpen} onClose={onClose} isCentered size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="#3D5A80" fontSize="lg">
          {t('profilePhotosVideos.addPhoto') || 'Add Photo'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <ImageUploader
            cropType={cropType}
            uploadCropedImg={uploadCropedImg}
            handlePopups={handlePopups}
            onProfilePostData={(e) => setProfilePostData(e)}
            isLoading={loading}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default GroupImgUploader;
